import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Button, Form, Offcanvas } from "react-bootstrap";
import "../Blog/BlogDetail.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import {
  faCalendarAlt,
  faFolder,
  faComment,
} from "@fortawesome/free-regular-svg-icons";
import Swal from "sweetalert2";
import { useLoader } from "../loader/LoaderContext";

const BlogDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useLoader();

  const [blogPost, setBlogPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [recentPosts, setRecentPosts] = useState([]);
  const [allBlogs, setAllBlogs] = useState([]);
  // const [blogCategories, setBlogCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [filteredBlogs, setFilteredBlogs] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [commentData, setCommentData] = useState({
    name: "",
    email: "",
    comment: "",
  });
  const [commentCharCount, setCommentCharCount] = useState(0);
  const [recentComments, setRecentComments] = useState([]);
  const [totalCommentCount, setTotalCommentCount] = useState(0);
  const [currentCommentPage, setCurrentCommentPage] = useState(1);
  const [commentsPerPage] = useState(3);
  const [show1, setShow1] = useState(false);
  const [isMarketFrozen, setIsMarketFrozen] = useState(false);
  const [freezeMessage, setFreezeMessage] = useState("");
  const [userName, setUserName] = useState("");
  const [credits, setCredits] = useState(0);
  const [inPlayValue, setInPlayValue] = useState(0);
  const [differenceValue, setDifferenceValue] = useState(0);
  const [playerval, setplayerval] = useState(0);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const isLoggedIn = !!localStorage.getItem("user_token");

  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);

  const handleLogout = () => {
    localStorage.removeItem("user_token");
    localStorage.removeItem("fullName");
    localStorage.removeItem("userId");
    localStorage.removeItem("user_isfrozen");
    localStorage.removeItem("email");
    console.log("User logged out successfully.");
    navigate("/");
  };

  const fetchMarketStatus = async () => {
    showLoader(true); // Start loader
    try {
      const Token = localStorage.getItem("user_token");
      const response = await axios.get(
        "https://toptennis.io/api/public/market-status",
        {
          // headers: { Authorization: `Bearer ${Token}` },
        }
      );

      // Extract values from the API response
      const { isFrozen, bannerText } = response.data;

      // Update state with both values
      setIsMarketFrozen(isFrozen);
      setFreezeMessage(bannerText || ""); // Ensure it's not undefined
      await fetchUserValues();
      hideLoader();
    } catch (error) {
      console.error("Error fetching market status:", error);
    } finally {
      hideLoader(); // Ensure loader stops after API response
    }
  };

  const fetchUserValues = async () => {
    const Token = localStorage.getItem("user_token");
    if (Token) {
      try {
        showLoader();
        const decodedToken = JSON.parse(atob(Token.split(".")[1]));
        const userId = decodedToken._id;
        const response = await axios.get(
          `https://toptennis.io/api/users/user/in-play-value/${userId}`,
          {
            headers: { Authorization: `Bearer ${Token}` },
          }
        );
        const {
          name,
          credits,
          grand_total_value,
          player_value_sum,
          differenceValue,
          latest_inc,
        } = response.data;
        setUserName(name);
        setCredits(credits);
        setInPlayValue(grand_total_value);
        setDifferenceValue(differenceValue);
        setplayerval(latest_inc);
      } catch (error) {
        console.error("Error fetching in-play values:", error);
      } finally {
        hideLoader();
      }
    }
  };

  useEffect(() => {
    fetchMarketStatus();
    fetchUserValues();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "comment") {
      // Limit comment to 500 characters
      if (value.length <= 500) {
        setCommentData({ ...commentData, [name]: value });
        setCommentCharCount(value.length);
      }
    } else {
      setCommentData({ ...commentData, [name]: value });
    }
  };

  const handleSubmitComment = async (e) => {
    const token = localStorage.getItem("user_token");
    e.preventDefault();

    try {
      showLoader();
      const response = await axios.post(
        "https://toptennis.io/api/users/addComment",
        {
          blogId: id,
          name: commentData.name,
          email: commentData.email,
          comment: commentData.comment,
        },
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 201) {
        Swal.fire({
          title: "Success!",
          text: "Comment submitted successfully.",
          icon: "success",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK",
        });
        setCommentData({ name: "", email: "", comment: "" });
        setCommentCharCount(0);
        setShowForm(false);
        // Reset to first page when new comment is added
        setCurrentCommentPage(1);
      }
    } catch (error) {
      console.error("Error submitting comment:", error);
    } finally {
      hideLoader();
    }
  };

  const removeHTMLTags = (text = "") => text.replace(/<[^>]*>/g, "");

  // Add new function to safely render HTML content
  const renderHTML = (html) => {
    return { __html: html };
  };

  useEffect(() => {
    const fetchBlogPost = async () => {
      try {
        showLoader();
        const token = localStorage.getItem("user_token");

        const [blogRes, recentRes] = await Promise.all([
          axios.get(`https://toptennis.io/api/public/singleblog/${id}`, {
            // headers: { authorization: `Bearer ${token}` },
          }),
          axios.get("https://toptennis.io/api/public/getAllBlog", {
            // headers: { authorization: `Bearer ${token}` },
          }),
        ]);

        const blogs = recentRes.data.blogs;

        setBlogPost(blogRes.data.blog);

        setRecentPosts(blogs.slice(0, 4));
        setAllBlogs(blogs);

        // const categories = [
        //   ...new Set(blogs.map((post) => post.category || "Uncategorized")),
        // ];
        // setBlogCategories(categories);

        setLoading(false);
      } catch (err) {
        console.error("Error fetching blog or recent posts:", err);
        setLoading(false);
      } finally {
        hideLoader();
      }
    };

    fetchBlogPost();
  }, [id]);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    setSearchQuery(""); // Clear search when category is clicked
    const filtered = allBlogs.filter(
      (blog) => (blog.category || "Uncategorized") === category
    );
    setFilteredBlogs(filtered);
  };

  useEffect(() => {
    const fetchRecentComments = async () => {
      try {
        showLoader();
        const token = localStorage.getItem("user_token");
        const response = await axios.get(
          `https://toptennis.io/api/users/getComment/${id}`,
          {
            headers: {
              authorization: `Bearer ${token}`,
            },
          }
        );
        setRecentComments(response.data.data);
        setTotalCommentCount(response.data.totalCount);
      } catch (error) {
        console.error("Error fetching recent comments:", error);
      } finally {
        hideLoader();
      }
    };

    fetchRecentComments();
  }, [id]);

  const handleSearch = async (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    setSelectedCategory(null); // Clear category filter when searching

    if (query.trim() === "") {
      setSearchResults([]);
      return;
    }

    try {
      showLoader();
      const token = localStorage.getItem("user_token");
      const res = await axios.get(
        `https://toptennis.io/api/public/searchBlogs?query=${query}`,
        {
          headers: { authorization: `Bearer ${token}` },
        }
      );
      setSearchResults(res.data.blogs || []);
    } catch (error) {
      console.error("Search error:", error);
    } finally {
      hideLoader();
    }
  };

  const handleSubscribe = () => {
    // Implement the subscribe logic here
    setMessage("Subscription logic not implemented yet.");
  };

  // Pagination functions for comments
  const indexOfLastComment = currentCommentPage * commentsPerPage;
  const indexOfFirstComment = indexOfLastComment - commentsPerPage;
  const currentComments = recentComments.slice(indexOfFirstComment, indexOfLastComment);
  const totalCommentPages = Math.ceil(recentComments.length / commentsPerPage);

  const handleCommentPageChange = (pageNumber) => {
    setCurrentCommentPage(pageNumber);
  };

  const handleNextCommentPage = () => {
    if (currentCommentPage < totalCommentPages) {
      setCurrentCommentPage(currentCommentPage + 1);
    }
  };

  const handlePrevCommentPage = () => {
    if (currentCommentPage > 1) {
      setCurrentCommentPage(currentCommentPage - 1);
    }
  };

  return (
    <Container className="blog-detail-container">
      <Row className="w-100 justify-content-center rowdiv">
        {isLoggedIn ? (
          <>
            <div className="freeze-banner">
              <p>{freezeMessage}</p>
            </div>
            <div className="user-info">
              <button
                variant="light"
                className="d-md-none menu-btn"
                onClick={handleShow1}
              >
                ☰
              </button>
              <div className="left-section1 d-flex1">
                <span className="welcome-text">Welcome, {userName}</span>
                <div className="top-navigation d-none d-md-flex">
                  <span className="nav-item" onClick={() => navigate("/home")}>
                    Home
                  </span>
                  <span
                    className="nav-item"
                    onClick={() => navigate("/profile")}
                  >
                    Profile
                  </span>
                  <span
                    className="nav-item"
                    onClick={() => navigate("/myteam")}
                  >
                    My Team
                  </span>
                  <span className="nav-item" onClick={() => navigate("/faq")}>
                    FAQs
                  </span>
                  <span
                    className="nav-item active"
                    onClick={() => navigate("/news")}
                  >
                    News
                  </span>
                  <span className="nav-item" onClick={handleLogout}>
                    Logout
                  </span>
                </div>
              </div>
              <Offcanvas show={show1} onHide={handleClose1} placement="start">
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title>Menu</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <div className="mobile-nav">
                    <span
                      className="nav-item"
                      onClick={() => {
                        navigate("/home");
                        handleClose1();
                      }}
                    >
                      Home
                    </span>
                    <span
                      className="nav-item"
                      onClick={() => {
                        navigate("/profile");
                        handleClose1();
                      }}
                    >
                      Profile
                    </span>
                    <span
                      className="nav-item"
                      onClick={() => {
                        navigate("/myteam");
                        handleClose1();
                      }}
                    >
                      My Team
                    </span>
                    <span
                      className="nav-item"
                      onClick={() => {
                        navigate("/news");
                        handleClose1();
                      }}
                    >
                      News
                    </span>
                    <span
                      className="nav-item"
                      onClick={() => {
                        navigate("/faq");
                        handleClose1();
                      }}
                    >
                      FAQs
                    </span>
                    <span
                      className="nav-item"
                      onClick={() => {
                        handleLogout();
                        handleClose1();
                      }}
                    >
                      Logout
                    </span>
                  </div>
                </Offcanvas.Body>
              </Offcanvas>
              <div className="right-section1">
                <div className="credit-box-container">
                  <button
                    className="topup-button"
                    onClick={() => {
                      navigate("/topup");
                    }}
                  >
                    Top-up
                  </button>
                  <div className="credit-box">
                    <p className="p">
                      Credit available: <span>{credits?.toFixed(2)}</span>
                    </p>
                    <p className="p">
                      In-play: <span>{inPlayValue.toFixed(2)}</span>
                    </p>
                    <p className="p">
                      Current Team P/L:&nbsp;
                      <span
                        style={{
                          color:
                            Number(differenceValue) > 0
                              ? "green"
                              : Number(differenceValue) < 0
                              ? "red"
                              : "black",
                        }}
                      >
                        {differenceValue
                          ? Number(differenceValue) > 0
                            ? `+${Number(differenceValue).toFixed(2)}`
                            : Number(differenceValue).toFixed(2)
                          : "0.00"}
                      </span>
                      &nbsp;
                      {/* <span className="pl-inc">
                        (Inc&nbsp;
                        <span
                          style={{
                            color:
                              Number(playerval) > 0
                                ? "green"
                                : Number(playerval) < 0
                                ? "red"
                                : "black",
                          }}
                        >
                          {playerval
                            ? Number(playerval) > 0
                              ? `+${Number(playerval).toFixed(2)}`
                              : Number(playerval).toFixed(2)
                            : "0.00"}
                        </span>
                        )
                      </span> */}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="freeze-banner">
            <p>{freezeMessage}</p>
          </div>
        )}
      </Row>

      <Row className="justify-content-center">
        <Col lg={9} className="blog-side">
          {loading ? (
            <div className="text-center">Loading...</div>
          ) : searchQuery ? (
            <div className="search-results mt-4">
              <h4>Search Results for "{searchQuery}"</h4>
              {searchResults.length === 0 ? (
                <p>No blogs found.</p>
              ) : (
                <ul className="filtered-blogs">
                  {searchResults.map((blog) => (
                    <li
                      key={blog._id}
                      onClick={() => {
                        setSearchQuery("");
                        setSearchResults([]);
                        navigate(`/blog/${blog._id}`);
                      }}
                      style={{ cursor: "pointer", marginBottom: "15px" }}
                    >
                      <div className="search-result-item">
                        {blog.fullImg && (
                          <div className="blog-detail-image">
                            <img
                              src={`https://toptennis.io/api/${blog.fullImg}`}
                              alt={blog.title}
                              className="image-fluid"
                            />
                          </div>
                        )}
                        <div className="blog-detail-header">
                          <h1 className="blog-title">
                            {removeHTMLTags(blog.title)}
                          </h1>
                        </div>
                        <div className="blog-detail-content">
                          <div
                            dangerouslySetInnerHTML={renderHTML(
                              blog.description
                            )}
                          />
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ) : !blogPost ? (
            <div className="text-center">Blog post not found</div>
          ) : (
            <>
              {blogPost.fullImg && (
                <div className="blog-detail-image">
                  <img
                    src={`https://toptennis.io/api/${blogPost.fullImg}`}
                    alt={blogPost.title}
                    className="img-fluid"
                  />
                </div>
              )}

              <div className="blog-detail-header">
                <h1 className="blog-title">{removeHTMLTags(blogPost.title)}</h1>
                <div className="post-meta">
                  <span className="meta-item author">
                    <FontAwesomeIcon icon={faUser} className="meta-icon" />{" "}
                    {blogPost.author}
                  </span>
                  <span className="separator">·</span>
                  <span className="meta-item date">
                    <FontAwesomeIcon
                      icon={faCalendarAlt}
                      className="meta-icon"
                    />
                    {new Date(blogPost.createdAt).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </span>
                  <span className="separator">·</span>
                  {/* <span className="meta-item category">
                    <FontAwesomeIcon icon={faFolder} className="meta-icon" />
                    {blogPost.category || "Uncategorized"}
                  </span> */}
                  <span className="separator">·</span>
                  <span className="meta-item comments">
                    <FontAwesomeIcon icon={faComment} className="meta-icon" />
                    {totalCommentCount} Comments
                  </span>
                </div>
              </div>

              <div className="blog-detail-content">
                <div
                  dangerouslySetInnerHTML={renderHTML(blogPost.description)}
                />
              </div>

              {selectedCategory && (
                <div className="filtered-category-section mt-4">
                  <h4>Blogs in "{selectedCategory}"</h4>
                  <ul className="filtered-blogs">
                    {filteredBlogs.map((blog) => (
                      <li
                        key={blog._id}
                        onClick={() => navigate(`/blog/${blog._id}`)}
                        style={{ cursor: "pointer", marginBottom: "5px" }}
                      >
                        <div
                          dangerouslySetInnerHTML={renderHTML(blog.description)}
                        />
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </>
          )}
          <div className="leave-comment ">
            <Button
              variant="primary"
              onClick={() => setShowForm(!showForm)}
              className="commentbtn"
            >
              Leave a Comment
            </Button>
          </div>

          {showForm && (
            <div className="comment-overlay" onClick={() => setShowForm(false)}>
              <div
                className="comment-popup"
                onClick={(e) => e.stopPropagation()}
              >
                <h4 className="comment-head">Leave a Comment</h4>
                <Form onSubmit={handleSubmitComment}>
                  <Form.Group className="mb-3">
                    <Form.Label>Name*</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={commentData.name}
                      onChange={handleChange}
                      placeholder="Enter Name (required)"
                      required
                    />
                  </Form.Group>
                  {/* <Form.Group className="mb-3">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            name="email"
            value={commentData.email}
            onChange={handleChange}
            placeholder="Enter Email (require)"
            required
          />
        </Form.Group> */}
                  <Form.Group className="mb-3">
                    <Form.Label>Comment</Form.Label>
                    <Form.Control
                      as="textarea"
                      name="comment"
                      rows={4}
                      value={commentData.comment}
                      onChange={handleChange}
                      placeholder="Enter Comment (max 500 characters)"
                      required
                      maxLength={500}
                    />
                    <div className="char-counter">
                      <small className={`${commentCharCount >= 500 ? 'text-warning' : 'text-muted'}`}>
                        {commentCharCount}/500 characters
                      </small>
                    </div>
                  </Form.Group>
                  <div className="d-flex justify-content-between">
                    <Button
                      variant="success"
                      type="submit"
                      className="submit-comment"
                    >
                      Submit
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          )}
        </Col>

        <Col lg={3} className="blog-sidebar">
          <div className="sidebar-widget">
            <h4>SEARCH</h4>
            <input
              type="text"
              placeholder="Search..."
              className="search-inpput"
              value={searchQuery}
              onChange={handleSearch}
            />
          </div>

          <div className="sidebar-widget">
            <h4>Recent Posts</h4>
            <ul className="recent-posts">
              {recentPosts.map((post) => (
                <li
                  key={post._id}
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate(`/blog/${post._id}`)}
                >
                  {removeHTMLTags(post.title)}
                </li>
              ))}
            </ul>
          </div>

          <div className="sidebar-widget">
            <h4>Recent Comments</h4>
            <ul className="recent-comments">
              {recentComments.length === 0 ? (
                <li>No comments to show.</li>
              ) : (
                currentComments.map((comment, index) => (
                  <li key={index} style={{textAlign:"justify"}}>
                    <strong>{comment.name}</strong>: {comment.comment}
                  </li>
                ))
              )}
            </ul>

            {/* Pagination for comments */}
            {recentComments.length > commentsPerPage && (
              <div className="comment-pagination">
                <div className="pagination-info">
                  Showing {indexOfFirstComment + 1}-{Math.min(indexOfLastComment, recentComments.length)} of {recentComments.length} comments
                </div>
                <div className="pagination-controls">
                  <button
                    className="pagination-btn"
                    onClick={handlePrevCommentPage}
                    disabled={currentCommentPage === 1}
                  >
                    Previous
                  </button>
                  <span className="page-numbers">
                      <button
                        className={`page-number`}
                      >
                        {currentCommentPage}
                      </button>
                  </span>
                  {/* <span className="page-numbers">
                    {Array.from({ length: totalCommentPages }, (_, i) => i + 1).map((number) => (
                      <button
                        key={number}
                        className={`page-number ${currentCommentPage === number ? 'active' : ''}`}
                        onClick={() => handleCommentPageChange(number)}
                      >
                        {number}
                      </button>
                    ))}
                  </span> */}
                  <button
                    className="pagination-btn"
                    onClick={handleNextCommentPage}
                    disabled={currentCommentPage === totalCommentPages}
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* <div className="sidebar-widget">
            <h4>Categories</h4>
            <ul className="categories">
              {blogCategories.map((category, index) => (
                <li
                  key={index}
                  style={{
                    cursor: "pointer",
                    color: selectedCategory === category ? "blue" : "black",
                  }}
                  onClick={() => handleCategoryClick(category)}
                >
                  {category}
                </li>
              ))}
              <p
                style={{
                  cursor: "pointer",
                  color: "black",
                  marginTop: "8px",
                }}
                onClick={() => setSelectedCategory(null)}
              >
                Clear Filter
              </p>
            </ul>
          </div> */}
        </Col>
      </Row>
      <div className="card-footer-topup">
        <div className="footer">
          <div className="footer-firstline">
            <div className="footer-sub">
              <h4>Keep in touch</h4>
              <h5>Join our newsletter. We promise not to spam!</h5>
              <input
                type="email"
                placeholder="Email Address"
                className="footer-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button className="subscribe-btn" onClick={handleSubscribe}>
                Subscribe
              </button>
              {message && (
                <p style={{ marginTop: "10px", marginLeft: "5px" }}>
                  {message}
                </p>
              )}
            </div>

            <div className="footer-sub1">
              <h4>Quick links</h4>
              {localStorage.getItem("user_token") ? (
                <>
                  <a href="/home" className="footer-link">
                    Home
                  </a>
                  <a href="/profile" className="footer-link">
                    Profile
                  </a>
                  <a href="/myteam" className="footer-link">
                    My Team
                  </a>
                </>
              ) : null}
              <a href="/news" className="footer-link">
                News
              </a>
              <a href="/faq" className="footer-link">
                FAQs
              </a>
            </div>

            <div className="footer-sub1 secondicon">
              <h4>Socials</h4>
              <div className="social-icons">
                <a
                  href="https://www.facebook.com/toptennisio/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-circle"
                  style={{ textDecoration: "none" }}
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a
                  href="https://www.instagram.com/toptennisuk"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-circle"
                  style={{ textDecoration: "none" }}
                >
                  <i className="fab fa-instagram"></i>
                </a>
              </div>

              <div className="fl1">
                <a
                  href="/terms"
                  className="footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  T&Cs
                </a>
                <a
                  href="/privacy"
                  className="footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
                <span className="footer-link">Email: contact@toptennis.io</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default BlogDetail;
